import { getBreakpoint } from '@micro-apps/env';
import { useLayoutEffect, useState } from 'react';

export default function useBreakpoint({ isNavigation } = {}) {
	const [breakpoint, setBreakpoint] = useState(getBreakpoint(isNavigation));
	useLayoutEffect(() => {
		function updateBreakpoint() {
			setBreakpoint(getBreakpoint(isNavigation));
		}
		window.addEventListener('resize', updateBreakpoint);
		updateBreakpoint();
		return () => window.removeEventListener('resize', updateBreakpoint);
	}, []);
	return breakpoint;
}
